import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const rsTranslations: PluginDefaultTranslationsObject = {
  $schema: './транслатион-сцхема.јсон',
  'plugin-form-builder': {
    name: 'Име (мала слова, без посебних знакова)',
    add: 'Додај',
    allowedFileTypes: 'Дозвољени типови датотека',
    allowedFileTypesDescription:
      'Ограничите дозвољене типове датотека (нпр. слика/*, апликација/пдф). Оставите празно да бисте дозволили све врсте.',
    allowMultipleFiles: 'Дозволи више датотека',
    amountInCents: 'Износ у центима',
    basePrice: 'Основна цена',
    bcc: 'БЦЦ',
    brand: 'Бранд',
    cc: 'ЦЦ',
    checkboxPlural: 'Поља за потврду',
    checkboxSingular: 'Поље за потврду',
    checkedByDefault: 'Подразумевано означено',
    chooseConfirmationType:
      'Одаберите да ли желите да прикажете поруку на страници или да преусмерите на другу страницу након што пошаљу образац.',
    condition: 'Стање',
    confirmationMessage: 'Порука за потврду',
    confirmationType: 'Врста потврде',
    countryPlural: 'Цоунтри Фиелдс',
    countrySingular: 'Држава',
    creditCard: 'Кредитна картица',
    customURL: 'Прилагођени УРЛ',
    datePlural: 'Поља датума',
    dateSingular: 'Датум',
    defaultValue: 'Подразумевана вредност',
    divide: 'Дивиде',
    documentToLinkTo: 'Документ за повезивање',
    doesNotEqual: 'Није једнако',
    emailFrom: 'Емаил Фром',
    emailPlural: 'Поља е-поште',
    emailsDescription:
      'Пошаљите прилагођене имејлове када се образац пошаље. Користите листе раздвојене зарезима да пошаљете исти имејл већем броју прималаца. Да бисте референцирали вредност из овог обрасца, умотајте име тог поља двоструким витичастим заградама, тј. {{firstName}}. Можете да користите џокер знак {{*}} за излаз свих података и {{*:table}} да их форматирате као HTML табелу у имејлу.',
    emailSingular: 'Емаил',
    emailTo: 'Емаил То',
    equals: 'Једнако',
    field: 'Поље',
    fields: 'Поља',
    fieldWidth: 'Ширина поља (проценат)',
    hasAnyValue: 'Има било какву вредност',
    internalLink: 'Интерна веза',
    label: 'Лабел',
    maxFileSize: 'Максимална величина датотеке (бајтови)',
    maxFileSizeDescription:
      'Максимална величина датотеке у бајтовима. Оставите празно без ограничења.',
    message: 'Порука',
    messageDescription: 'Унесите поруку коју треба послати у овој е-поруци.',
    messagePlural: 'Блокови порука',
    messageSingular: 'Порука',
    mimeType: 'МИМЕ Типе',
    mimeTypePlural: 'МИМЕ типови',
    mimeTypeSingular: 'МИМЕ Типе',
    multiply: 'Помножите',
    numberPlural: 'Нумбер Фиелдс',
    numberSingular: 'Број',
    optionPlural: 'Опције',
    optionSingular: 'Опција',
    paymentFieldPlural: 'Поља за плаћање',
    paymentFieldSingular: 'Плаћање',
    paymentProcessor: 'Процесор плаћања',
    paymentStatus: 'Статус',
    placeholder: 'Чувар места',
    priceConditions: 'Услови цене',
    priceConditionsPlural: 'Услови цене',
    priceConditionsSingular: 'Прице Цондитион',
    radioOptions: 'Опције радио атрибута',
    radioPlural: 'Радио Фиелдс',
    radioSingular: 'Радио',
    redirect: 'Преусмери',
    replyTo: 'Одговори на',
    required: 'Обавезно',
    selectOptions: 'Изаберите Опције',
    selectPlural: 'Изаберите Поља',
    selectSingular: 'Изаберите',
    statePlural: 'Стате Фиелдс',
    stateSingular: 'Држава',
    staticValue: 'Статичка вредност',
    subject: 'Предмет',
    submitButton: 'Пошаљи ознаку дугмета',
    subtract: 'Одузми',
    textareaPlural: 'Тектареа Фиелдс',
    textareaSingular: 'Тектареа',
    textPlural: 'Тект Фиелдс',
    textSingular: 'Текст',
    title: 'Наслов',
    token: 'токен',
    uploadCollection: 'Отпреми колекцију',
    uploadCollectionDescription:
      'Изаберите колекцију за отпремање у коју ћете складиштити датотеке',
    uploadFieldPlural: 'Уплоад Фиелдс',
    uploadFieldSingular: 'Уплоад',
    urlToRedirectTo: 'УРЛ за преусмеравање',
    value: 'Валуе',
    valueOfField: 'Вредност поља',
    valueType: 'Врста вредности',
  },
}

export const rs: PluginLanguage = {
  dateFNSKey: 'rs',
  translations: rsTranslations,
}
